import { AddBirthdaySubscriptionFormType } from './AddBirthdaySubscriptionFormType';

export const createInitialValues = (): AddBirthdaySubscriptionFormType => ({
  day: 1,
  month: "01",
  nickname: "",
  email: "",
  phone: "",
});
